import { Attributes, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";
import { TextConstants } from "../../../../Common/TextConstants";

@NeoModel
export default class RawGenericMappingLookup extends ModelBase {
    public rawGenericMappingID: number = 0;

    @Rules.Required()
    public staticFileSpecID: number = 0;

    public fileSpecProperties: string = "";

    @Rules.Required()
    @Attributes.Display("Source Table")
    public rawGenericSourceTableName: string = "";

    @Rules.Required()
    @Attributes.Display("Source Field")
    public rawGenericSourceField: string = "";

    @Rules.Required()
    public destinationTableId: number = 0;

    @Rules.Required()
    public destinationFieldId: number = 0;
    
    @Attributes.Display("Destination Table")
    public rawGenericDestinationTableName: string = "";
    
    @Attributes.Display("Destination Field")
    public rawGenericDestinationField: string = "";

    public defaultValue: string | null = null;

    public calculation: string | null = null;

    public genericJoinFieldInd: boolean = false;

    @Attributes.Integer()
    public iteration: number = 0;

    public fileTypeConcatenated: string | null = null;

    public sourceFieldIsCalculatedInd: boolean | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(i => (i.calculation === null || i.calculation === "") && i.rawGenericSourceField === TextConstants.SourceFieldStaticOptions.Calc , TextConstants.Validation.CalculationLogic);
        rules.failWhen(i => (i.defaultValue === null || i.defaultValue === "") && i.rawGenericSourceField === TextConstants.SourceFieldStaticOptions.Default, TextConstants.Validation.DefaultValue);
    }
}